/**
 * Jambuveda — hover-to-open for the header's "Health Concerns" mega menu
 * Dawn's native menu uses the standard <details>/<summary> pattern and only
 * opens on click, by design (this is the more accessible default for touch
 * and keyboard users). This adds hover-to-open on desktop/mouse devices
 * only, matching the original Claude Design, WITHOUT removing or breaking
 * the existing click behavior for mobile/touch/keyboard users.
 */
(function () {
  // Only run on devices with real hover + a precise pointer (desktop mouse).
  // Touch devices are untouched, so tapping still works exactly as before.
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('header details, header-menu details').forEach(function (details) {
    const summary = details.querySelector('summary');
    if (!summary) return;
    let closeTimer;

    details.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });
    details.addEventListener('mouseleave', function () {
      // Small delay so moving from the button into the dropdown doesn't flicker-close it
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });
  });
})();
